import adminApi from '@/api/admin';

const APPEND_SALES_MONITORING = 'APPEND_SALES_MONITORING';
const SET_IS_FETCHING = 'SET_IS_FETCHING';
const SET_IS_FETCHED = 'SET_IS_FETCHED';
const SET_IS_ALL = 'SET_IS_ALL';
const ADD_PAGE = 'ADD_PAGE';
const RESET_SALES_MONITORING = 'RESET_SALES_MONITORING';
const SET_PAGE_INFO = 'SET_PAGE_INFO';

const state = {
	all: [],
	isFetching: false,
	isAll: false,
	page: 1,
	isFetched: false,
	pageInfo: null,
};

const getters = {
	allSalesMonitoring: state => state.all,
	isFetching: state => state.isFetching,
	isAll: state => state.isAll,
	page: state => state.page,
	isFetched: state => state.isFetched,
	pageInfo: state => state.pageInfo,
};

const mutations = {
	[APPEND_SALES_MONITORING](state, salesMonitoring) {
		state.all = state.all.concat(salesMonitoring);
	},
	[RESET_SALES_MONITORING](state) {
		state.all = [];
		state.isAll = false;
		state.page = 1;
	},
	[SET_IS_FETCHING](state, status) {
		state.isFetching = status;
	},
	[SET_IS_FETCHED](state, status) {
		state.isFetched = status;
	},
	[SET_IS_ALL](state, status) {
		state.isAll = status;
	},
	[ADD_PAGE](state) {
		state.page++;
	},
	[SET_PAGE_INFO](state, pageInfo) {
		state.pageInfo = pageInfo;
	},
};

const actions = {
	getSalesMonitoring({ commit, getters }, params) {
		if (!getters.isFetching) {
			commit(SET_IS_FETCHING, true);
			const callback = (response) => {
				const salesMonitoring = response.data;
				if (response.data?.page_info) {
					const pageInfo = response.data.page_info;
					commit(SET_PAGE_INFO, pageInfo);
				}
				if (salesMonitoring !== null && salesMonitoring.length !== 0) {
					commit(APPEND_SALES_MONITORING, salesMonitoring);
					commit(ADD_PAGE);
				} else {
					commit(SET_IS_ALL, true);
				}
				commit(SET_IS_FETCHING, false);
				commit(SET_IS_FETCHED, true);
			};
			const errorCallback = (e) => {
				// eslint-disable-next-line
				console.log(e);
				commit(SET_IS_FETCHED, true);
			};
			adminApi.getSalesMonitoring(params, callback, errorCallback);
		}
	},
	resetSalesMonitoring({ commit }) {
		commit(RESET_SALES_MONITORING);
	},
};

export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations,
};
